import React from 'react';
import { Form, Input, Select } from 'antd';
import { PROFESSIONAL_INTEREST_AREAS } from '../../../../Utils/sriLankaGeoData';

const { Option } = Select;
const { TextArea } = Input;

const Section06Skills = () => {
  return (
    <div className="section-container">
      <div className="section-header">
        <span className="section-badge">SECTION 06</span>
        <h3>Skills & Career Interests</h3>
        <p className="section-description">
          Help IBAS understand your professional aspirations so we can recommend customized workshops, advanced modules, and career pathways.
        </p>
      </div>

      <div className="form-grid">
        <Form.Item
          label="Professional Areas of Interest"
          name="interestedAreas"
          rules={[{ required: true, message: 'Please select at least one professional interest area' }]}
          extra="Select all disciplines that align with your career goals"
        >
          <Select
            mode="multiple"
            size="large"
            placeholder="Select professional interest areas"
            allowClear
          >
            {PROFESSIONAL_INTEREST_AREAS.map((area) => (
              <Option key={area} value={area}>
                {area}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Specific Skills You Want to Develop"
          name="skillsToDevelop"
          rules={[{ required: true, message: 'Please state what skills you aim to master' }]}
          extra="Type skills and press Enter (e.g. Advanced Excel Macros, Financial Modeling, Power BI Dashboards, SQL, Inventory Management)"
        >
          <Select
            mode="tags"
            size="large"
            placeholder="e.g. Financial Modeling, Power BI, Python, Business English"
            tokenSeparators={[',']}
          />
        </Form.Item>

        <div className="grid-two-cols">
          <Form.Item label="Current Key Skills (Optional)" name="currentSkills">
            <Input placeholder="e.g. Bookkeeping, Team Leadership, Report Writing" size="large" />
          </Form.Item>

          <Form.Item label="Current Software Skills (Optional)" name="softwareSkills">
            <Input placeholder="e.g. MS Excel (Intermediate), QuickBooks, Sage, SPSS" size="large" />
          </Form.Item>
        </div>

        <Form.Item label="Your Career Goal / Dream Role" name="careerGoal" extra="Recommended">
          <Input placeholder="e.g. Chief Financial Officer / Lead Data Analyst / Supply Chain Consultant" size="large" />
        </Form.Item>

        <Form.Item label="Other Courses or Certifications You Are Interested In" name="coursesInterestedIn" extra="Recommended">
          <TextArea rows={2} placeholder="e.g. Diploma in Logistics & Supply Chain, Power BI Masterclass, AI for Business" />
        </Form.Item>
      </div>
    </div>
  );
};

export default Section06Skills;
